import { render, staticRenderFns } from "./caracteristicasCategoria.vue?vue&type=template&id=5d289d43&scoped=true"
import script from "./caracteristicasCategoria.vue?vue&type=script&lang=js"
export * from "./caracteristicasCategoria.vue?vue&type=script&lang=js"
import style0 from "./caracteristicasCategoria.vue?vue&type=style&index=0&id=5d289d43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d289d43",
  null
  
)

export default component.exports